// src/pages/ModeSelection.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaRulerCombined, FaVectorSquare } from "react-icons/fa";
import "./ModeSelection.css";

export default function ModeSelection() {
  const navigate = useNavigate();

  return (
    <div className="mode-container">
      <h1 className="mode-title">Select Measurement Mode</h1>
      <p className="mode-subtitle">
        Choose how you want to measure your project.
      </p>

      <div className="mode-grid">

        {/* ── SURFACE MODE ── */}
        <div
          className="mode-card mode-card--surface"
          onClick={() => navigate("/surface-mode")}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && navigate("/surface-mode")}
          aria-label="Use Surface Mode"
        >
          <div className="mode-header surface-header">
            <FaVectorSquare className="mode-icon" />
            <h2>Surface Mode</h2>
          </div>
          <p className="mode-description">
            Ideal for backsplashes, shower walls, countertops, fireplace
            surrounds, windows, and other flat surfaces.
            <br /><br />
            Use this mode when your project fits inside a single photo.
            Upload one image and tap two points to measure width and height
            using AI-assisted scaling.
          </p>
          <div className="mode-btn mode-btn--surface">
            Use Surface Mode
          </div>
        </div>

  {/* ── KITCHEN MODE ── */}
<div
  className="mode-card mode-card--kitchen"
  onClick={() => navigate("/kitchen-mode")}
  role="button"
  tabIndex={0}
  onKeyDown={(e) => e.key === "Enter" && navigate("/kitchen-mode")}
  aria-label="Use Kitchen Mode"
>
  <div className="mode-header kitchen-header">
    <FaVectorSquare className="mode-icon" />
    <h2>Kitchen Mode</h2>
  </div>
  <p className="mode-description">
    Built for kitchen designers and cabinet planning. Measure each wall
    of the kitchen — cabinet runs, pantry, island walls.
    <br /><br />
    Pick your layout (L-shape or U-shape), measure each wall, and get a
    labeled kitchen diagram with total run and area — no site visit needed.
  </p>
  <div className="mode-btn mode-btn--kitchen">Use Kitchen Mode</div>
</div>

        {/* ── ROOM MODE ── */}
        <div
          className="mode-card mode-card--room"
          onClick={() => navigate("/multiroom")}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && navigate("/multiroom")}
          aria-label="Use Room Mode"
        >
          <div className="mode-header room-header">
            <FaRulerCombined className="mode-icon" />
            <h2>Room Mode</h2>
          </div>
          <p className="mode-description">
            Perfect for full rooms, flooring projects, or large spaces where
            depth and perspective affect scale.
            <br /><br />
            Capture separate photos for width and length, and the AI Stick v2
            will compute accurate room dimensions — even with perspective.
          </p>
          <div className="mode-btn mode-btn--room">
            Use Room Mode
          </div>
        </div>

      </div>
    </div>
  );
}
